import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import RouteSeo from './components/RouteSeo';
import { Toaster } from './components/ui/sonner';
import { CookieConsent } from './components/CookieConsent';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <RouteSeo />
          <Toaster position="top-right" theme="dark" />
          <CookieConsent />
          <ErrorBoundary>
            <AppRoutes />
          </ErrorBoundary>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
